<div class="top-info-banner">
    <div class="banner-content">
        <div class="banner-item" (click)="modal.open('sucursal-modal-1')">
            <i class="mdi mdi-map-marker banner-icon" style="color: white; font-size: 0.75rem;"></i>
            <span class="clickable">Seleccionar método de entrega</span>
        </div>
    </div>
</div>

<div class="header-main" [class.is-scrolled]="scroll">
    <div class="header-container">
        <div class="brand-section">
            <div class="logo-wrapper" (click)="iraLand()">
                <img [src]="logosrc" class="main-logo" alt="logo">
            </div>
        </div>

        <div class="actions-section">
            <div class="ayuda-link" (click)="irAyuda()">
                <i class="mdi mdi-help-circle-outline"></i>
                <span>Ayuda</span>
            </div>
        </div>
    </div>
</div>
<div class="normalicedscreen">
    <router-outlet></router-outlet>
</div>